export default __webpack_public_path__ + "static/media/logo.e5e48e6a.png";